export default class LocationSearchAnalytics {
  constructor(store, container) {
    this.store = store;
    this.container = container;
    this.analyticsUrl = window.ajaxurl || "/wp-admin/admin-ajax.php";
  }

  formatData(locationId) {
    const data = {
      action: "location_analytics",
      event_type: this.store.activeTypeValue || "none",
      capacity: this.store.minimumCapacity,
      lineup: this.store.selectedLineup || "all",
      location_id: locationId,
    };
    return data;
  }

  trackLocationClick(locationId) {
    try {
      if (this.analyticsUrl && locationId) {
        const wpPayload = this.formatData(locationId);

        const formData = new FormData();
        Object.keys(wpPayload).forEach((key) => {
          formData.append(key, wpPayload[key]);
        });

        fetch(this.analyticsUrl, {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            if (!data.success) {
              console.warn("Analytics submission failed:", data.error);
            }
          })
          .catch((error) => {
            console.error("Error sending WordPress analytics:", error);
          });
      }
    } catch (error) {
      console.error("Error sending analytics event:", error);
    }
  }
}
